import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import { List, Typography } from '@mui/material';


import SidebarMenuListItem from './SidebarMenuListItem';

const SidebarMenuList = props => {
  const { pages, ...rest } = props;
  const location = useLocation();

  // Safety check - ensure we have pages and location
  if (!pages || !location) {
    return <List className="p-0" />;
  }

  return (
    <List className="p-0">
      {pages.reduce(
        (items, page) => reduceChildRoutes({ items, page, location, ...rest }),
        []
      )}
    </List>
  );
};

SidebarMenuList.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array
};

const reduceChildRoutes = props => {
  const { location, items, page, depth } = props;

  // Safety check for page object
  if (!page) {
    return items;
  }

  if (page.content) {
    // Safety check for location and pathname
    const pathname = location?.pathname || '/';
    const pagePath = page.to || '/';
    
    // Only auto-expand if there's an exact match or the current path is a direct child
    // This prevents over-expansion of menu items
    let open = false;
    
    // Check for exact match first
    if (pathname === pagePath) {
      open = true;
    } else {
      // Check if any child page matches the current route
      const hasMatchingChild = page.content.some(child => 
        child.to && pathname === child.to
      );
      open = hasMatchingChild;
    }

    items.push(
      <SidebarMenuListItem
        depth={depth}
        icon={page.icon}
        key={page.label}
        label={page.badge}
        open={Boolean(open)}
        title={page.label}>
        <div className="sidebar-menu-children py-2">
          <SidebarMenuList
            depth={depth + 1}
            pages={page.content}
          />
        </div>
      </SidebarMenuListItem>
    );
  } else {
    items.push(
      <SidebarMenuListItem
        depth={depth}
        href={page.to}
        icon={page.icon}
        key={page.label}
        label={page.badge}
        title={page.label}
      />
    );
  }

  return items;
};

const SidebarMenu = props => {
  const { title, pages, className, component: Component, ...rest } = props;

  return (
    <Component {...rest} className={className}>
      {title && (
        <Typography className="app-sidebar-heading">{title}</Typography>
      )}
      <SidebarMenuList depth={0} pages={pages} />
    </Component>
  );
};

SidebarMenu.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string
};

SidebarMenu.defaultProps = {
  component: 'nav'
};

export default SidebarMenu;
